/* ==========================================================================
   Quick add modal
   --------------------------------------------------------------------------
   Renders the "Quick add preview" section for the chosen product inside a
   sheet.

   quick-add-preview is a STATIC section, rendered from layout/theme.liquid
   with {% section 'quick-add-preview' %}. That matters: a static section's id
   is its file name, so ?section_id=quick-add-preview returns the settings and
   blocks saved in the theme editor. A section placed in a section group gets
   a generated instance id instead, which does not resolve here.
   ========================================================================== */

const QUICK_ADD_SECTION_ID = 'quick-add-preview';

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      buildUrl(productUrl) {
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('section_id', QUICK_ADD_SECTION_ID);
        return url.toString();
      }

      show(opener) {
        const productUrl = opener.getAttribute('data-product-url');
        if (!productUrl) return;

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(this.buildUrl(productUrl))
          .then((response) => {
            if (!response.ok) throw new Error('Quick add: bad response');
            return response.text();
          })
          .then((responseText) => {
            const doc = new DOMParser().parseFromString(responseText, 'text/html');
            const preview = doc.querySelector('[data-qa-preview]');
            if (!preview) throw new Error('Quick add: preview markup not found');

            // Collect the section's own <style> and <script> alongside the markup
            const wrapper = document.createElement('div');
            doc.querySelectorAll('style').forEach((node) => wrapper.appendChild(node.cloneNode(true)));
            wrapper.appendChild(preview.cloneNode(true));
            doc.querySelectorAll('script:not([type="application/json"])').forEach((node) => {
              if (node.src) return;
              wrapper.appendChild(node.cloneNode(true));
            });

            this.setInnerHTML(this.modalContent, wrapper.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            super.show(opener);
          })
          .catch((error) => {
            console.warn(error);
            window.location.href = productUrl;
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    }
  );
}
